import { render, staticRenderFns } from "./LegendPanel.vue?vue&type=template&id=2097091c&scoped=true&"
import script from "./LegendPanel.vue?vue&type=script&lang=js&"
export * from "./LegendPanel.vue?vue&type=script&lang=js&"
import style0 from "./LegendPanel.vue?vue&type=style&index=0&id=2097091c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2097091c",
  null
  
)

export default component.exports